import { Injectable } from '@angular/core';
import { SiteDriveOdataItem } from '@common/models';
import { ODataPagedResult } from '@common/odata';
import { SharedOdataService } from '@common/services/shared.odata.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SiteItemsTreeOdataService extends SharedOdataService<SiteDriveOdataItem> {
  public accessor dateTime: string = null;

  constructor() {
    super('SiteItems');
    this.pageSize = 100;
    this.orderBy = 'Name asc';
  }

  clearCache() {
    this.filter = '';
  }

  siteItems(): Observable<ODataPagedResult<SiteDriveOdataItem>> {
    return this.odataFactory
      .CreateService<SiteDriveOdataItem>('SiteItems/GetActiveSiteItems')
      .Query()
      .Top(this.pageSize)
      .Skip(this.pageSize * (this.page - 1))
      .Filter(this.filter)
      .OrderBy(this.orderBy || 'BackupOn desc, Name asc')
      .ExecWithCount();
  }

  listsOfSiteItems(blockId: string, id?: string): Observable<ODataPagedResult<SiteDriveOdataItem>> {
    return this.odataFactory
      .CreateService<SiteDriveOdataItem>(`/SiteItems(${blockId})/Lists`)
      .Query()
      .Top(this.pageSize)
      .Skip(this.pageSize * (this.page - 1))
      .Filter(this.filter)
      .OrderBy(this.orderBy)
      .CustomQueryOptions([{ key: 'Id', value: id }])
      .ExecWithCount();
  }

  driveItemsOfSiteLists(blockId: string, id: string): Observable<ODataPagedResult<SiteDriveOdataItem>> {
    const customQueryOptions = [{ key: 'Id', value: id }];

    if (this.dateTime) {
      customQueryOptions.push({ key: 'dateTime', value: this.dateTime });
    }

    return this.odataFactory
      .CreateService<SiteDriveOdataItem>(`/SiteLists(${blockId})/DriveItems`)
      .Query()
      .Top(this.pageSize)
      .Skip(this.pageSize * (this.page - 1))
      .Filter(this.filter)
      .OrderBy(this.orderBy)
      .CustomQueryOptions(customQueryOptions)
      .ExecWithCount();
  }

  listItemsOfSiteLists(blockId: string, id: string): Observable<ODataPagedResult<SiteDriveOdataItem>> {
    return this.odataFactory
      .CreateService<SiteDriveOdataItem>(`/SiteLists(${blockId})/ListItems`)
      .Query()
      .Top(this.pageSize)
      .Skip(this.pageSize * (this.page - 1))
      .Filter(this.filter)
      .OrderBy(this.orderBy)
      .CustomQueryOptions([{ key: 'Id', value: id }])
      .ExecWithCount();
  }
}
